import Form from '@components/form/Form';
import FormRow from 'lib/src/components/form/FormRow';
import TextInput from '@components/form/TextInput';
import Modal from '@components/modal/Modal';
import usePrevious from 'lib/src/hooks/usePrevious';
import React, { useEffect } from 'react';
import { User } from 'src/types/shared/User';
import useUpdateUserPassword from './hooks/useUpdateUserPassword';
import usePasswordValidation from 'lib/src/hooks/usePasswordValidation';

const UpdateUserPasswordModal: React.FC<UpdateUserModalProps> = ({ user: { id }, closeModal }) => {
    const {
        formState: { password, confirmPassword },
        handleChange,
        handleSubmit,
        isPosting,
        postSuccess,
    } = useUpdateUserPassword(id);
    const { validatePassword, validateConfirmPassword } = usePasswordValidation(password);

    const prevPostSuccess = usePrevious(postSuccess);

    useEffect(() => {
        if (postSuccess && !prevPostSuccess) closeModal();
    }, [postSuccess, prevPostSuccess, closeModal]);

    return (
        <Modal title="Update password" size="small" closeModal={closeModal}>
            <Form onCancel={closeModal} onSubmit={handleSubmit} isPosting={isPosting}>
                <FormRow>
                    <TextInput
                        required
                        type="password"
                        name="password"
                        value={password}
                        onChange={handleChange}
                        label="Password"
                        customValidate={validatePassword}
                    />
                </FormRow>
                <FormRow>
                    <TextInput
                        required
                        type="password"
                        name="confirmPassword"
                        value={confirmPassword}
                        onChange={handleChange}
                        customValidate={validateConfirmPassword}
                        label="Confirm password"
                    />
                </FormRow>
            </Form>
        </Modal>
    );
};

interface UpdateUserModalProps {
    user: User;
    closeModal: () => void;
}

export default UpdateUserPasswordModal;
